import React from 'react';
import "./Products.css"

export default function SectionHeader({title, subtitle}) {
  return (
    <div className="section_heading text-center">
            <h2>{title}</h2>
            <p>{subtitle}</p>
    </div>
  )
}


